import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I Got Schooled",
  "description": "",
  "published": "2016-09-02T00:00:00.000Z",
  "redirect_from": ["/blog/i-got-schooled/swizec/6997"],
  "categories": "Business, Learning, Personal, Side Projects",
  "hero": "./img/F5ryCT5.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "638px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/02a4e42b5d2d8d31ea1048ea211c7c59/41be6/F5ryCT5.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.390134529147986%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'125\\'%20viewBox=\\'0%200%20400%20125\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M65%207c-5%202-6%205-4%207l32%202%2038%201h63l39-1h34l3-3%201-2h-2c2-3-5-3-91-4A2192%202192%200%200165%207m229%2070c-2%202-2%202-3%201h-2l1%201v1c-1%201-1%201%201%201l3-2h1c0%202%201%202%203%202%203%200%204-1%204-2h1c0%201%201%202%204%202l3-1-1-2%203%201c1%202%204%203%204%201h1l2%201c2%200%202%200%201-1l-1-2-1-2c-1-1-1-1-1%201h-8c-1%201-2%200-3-1-3-1-4-1-4%201l-2%201c-2-1-3%200-3%201l-1-1-1-3-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/02a4e42b5d2d8d31ea1048ea211c7c59/ca0a1/F5ryCT5.webp 223w", "/static/02a4e42b5d2d8d31ea1048ea211c7c59/75680/F5ryCT5.webp 445w", "/static/02a4e42b5d2d8d31ea1048ea211c7c59/a2d8a/F5ryCT5.webp 638w"],
              "sizes": "(max-width: 638px) 100vw, 638px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/02a4e42b5d2d8d31ea1048ea211c7c59/e92b6/F5ryCT5.png 223w", "/static/02a4e42b5d2d8d31ea1048ea211c7c59/e66bf/F5ryCT5.png 445w", "/static/02a4e42b5d2d8d31ea1048ea211c7c59/41be6/F5ryCT5.png 638w"],
              "sizes": "(max-width: 638px) 100vw, 638px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/02a4e42b5d2d8d31ea1048ea211c7c59/41be6/F5ryCT5.png",
              "alt": "F5ryCT5",
              "title": "F5ryCT5",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Steve’s right. He got the last email in my 10-day email sequence, and it doesn’t even link back to my site. It’s my very last chance at a sale before I shut up about `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`The Book`}</a>{` and send you only the regular emails that I send.`}</p>
    <p>{`And yet, no link. Nothing for you to do but to focus on my failings and answer the question `}<em parentName="p">{`“Why didn’t you open your wallet? Don’t you want it?”`}</em></p>
    <p>{`1.2% of recipients who get that far unsubscribe. That’s 8 people. Of course, only 45% even open the email. That’s 294 people.`}</p>
    <p>{`4.5% reply. That’s 29 people in the five months.`}</p>
    <p>{`This is the only email in the whole sequence with a reply rate higher than 0.0%.`}</p>
    <p>{`But no sales.`}</p>
    <p>{`At least, none that I can attribute to this email. Hell, none of my sales get attributed to any of these emails. Gumroad lumps it all together with Direct, anyway.`}</p>
    <p>{`49 sales from Direct/Email/IM vs. 316 sales from the landing page itself.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "538px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4454b4803968df8c6fc7d41b2e76d4c5/9516f/cGHt0lV.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.14798206278027%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'117\\'%20viewBox=\\'0%200%20400%20117\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M46%2090l-2%202%202%202c1%202%204%201%204-1v-1l1%202%201%201%201-2%201-3%201%203%201%202%201-2%201-3%201%203%201%202h5c2%200%203-5%201-6s-4%200-4%202c1%202%200%202-1%200-2-3-9-3-10-1h-1c0-2-3-2-4%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4454b4803968df8c6fc7d41b2e76d4c5/ca0a1/cGHt0lV.webp 223w", "/static/4454b4803968df8c6fc7d41b2e76d4c5/75680/cGHt0lV.webp 445w", "/static/4454b4803968df8c6fc7d41b2e76d4c5/b52d2/cGHt0lV.webp 538w"],
              "sizes": "(max-width: 538px) 100vw, 538px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4454b4803968df8c6fc7d41b2e76d4c5/e92b6/cGHt0lV.png 223w", "/static/4454b4803968df8c6fc7d41b2e76d4c5/e66bf/cGHt0lV.png 445w", "/static/4454b4803968df8c6fc7d41b2e76d4c5/9516f/cGHt0lV.png 538w"],
              "sizes": "(max-width: 538px) 100vw, 538px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/4454b4803968df8c6fc7d41b2e76d4c5/9516f/cGHt0lV.png",
              "alt": "cGHt0lV",
              "title": "cGHt0lV",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The conversion rate also looks much better without the emails. ?`}</p>
    <p>{`And yet, a significant amount of traffic coming to the website originates in email. Just under 9%.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "545px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e350321b306900887b5d85d850203d35/3ddad/DfwSxBc.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "91.92825112107623%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'367\\'%20viewBox=\\'0%200%20400%20367\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M144%2024c-2%204-1%206%200%202h4c2%202%202%202%202%200l1%201h6l2%201%202%201v1l1-4c0-4%200-5-2-5l-2%201h-3c-2-1-2-1-4%201l-2%202-1-3c-1-4-3-4-4%202m106%2074h-26v16h53V97l-27%201m-26%2048v8h34v-16h-34v8m0%2041v8h31v-17h-31v9m0%2040v8h25v-16h-25v8m0%2041v8h12v-17h-12v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e350321b306900887b5d85d850203d35/ca0a1/DfwSxBc.webp 223w", "/static/e350321b306900887b5d85d850203d35/75680/DfwSxBc.webp 445w", "/static/e350321b306900887b5d85d850203d35/6305f/DfwSxBc.webp 545w"],
              "sizes": "(max-width: 545px) 100vw, 545px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e350321b306900887b5d85d850203d35/e92b6/DfwSxBc.png 223w", "/static/e350321b306900887b5d85d850203d35/e66bf/DfwSxBc.png 445w", "/static/e350321b306900887b5d85d850203d35/3ddad/DfwSxBc.png 545w"],
              "sizes": "(max-width: 545px) 100vw, 545px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/e350321b306900887b5d85d850203d35/3ddad/DfwSxBc.png",
              "alt": "DfwSxBc",
              "title": "DfwSxBc",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I have no idea where all those Direct users come from. It’s not like anyone types `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js/"
      }}>{`swizec.com/reactd3js`}</a>{` into their browser. That would be strange.`}</p>
    <p>{`Well, okay. `}<em parentName="p">{`I`}</em>{` type it in all the time when I check stuff. But I’m pretty sure I’m the only person in the world who does that.`}</p>
    <p>{`Could those 8,603 people come from email as well? If they are, that changes things. It makes the intricate email marketing setup worth it. ?`}</p>
    <p>{`I mean, with that one FB Lead Ad that I have running, I’m paying $1.20 for each of those leads. And I just found out that I stupidly have double opt-in set up, and many people never actually sign up after already costing me a conversion on Facebook.`}</p>
    <p>{`Not that I’m complaining about one dollar, but that shit ads up.`}</p>
    <p>{`I have no idea what I’m doing, obviously. But sometimes I get emails like this, and that gives me hope:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "569px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/150834c08f86aac3ba174c552c12c15b/854dc/5MRoXQc.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "17.040358744394617%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'67\\'%20viewBox=\\'0%200%20400%2067\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%202c-2%200-3%201-3%202l-2%201c-2%200-2%201-2%203%200%201%200%202%201%201%200-2%202-3%202%200l1%201h2l9%201%2010%201c2%202%2014%202%20109%201%20100-1%2098-1%2099-6%200-4-2-5-25-4-19%201-23%200-25-1h-15A1773%201773%200%200147%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/150834c08f86aac3ba174c552c12c15b/ca0a1/5MRoXQc.webp 223w", "/static/150834c08f86aac3ba174c552c12c15b/75680/5MRoXQc.webp 445w", "/static/150834c08f86aac3ba174c552c12c15b/0fe84/5MRoXQc.webp 569w"],
              "sizes": "(max-width: 569px) 100vw, 569px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/150834c08f86aac3ba174c552c12c15b/e92b6/5MRoXQc.png 223w", "/static/150834c08f86aac3ba174c552c12c15b/e66bf/5MRoXQc.png 445w", "/static/150834c08f86aac3ba174c552c12c15b/854dc/5MRoXQc.png 569w"],
              "sizes": "(max-width: 569px) 100vw, 569px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/150834c08f86aac3ba174c552c12c15b/854dc/5MRoXQc.png",
              "alt": "5MRoXQc",
              "title": "5MRoXQc",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`PS: the email with the most unsubscribes says `}<em parentName="p">{`“Yo, look at all these other people who liked my thing”`}</em>{` and shows some testimonials –> 1.9% unsubscribes. ¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      